module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Master_Path.291bd0fb.jpg";